import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { JumpPoints } from '../components/JumpPoints';
import { QueueCard } from '../components/QueueCard';
import { AttentionCard } from '../components/AttentionCard';
import { ClosingsCard } from '../components/ClosingsCard';
import { ProductionSnapshot } from '../components/ProductionSnapshot';
import { ActivityFeed } from '../components/ActivityFeed';
import { currentUser } from '../data/mockData';
export function Overview() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-926" data-mp="2hizc8ha8l8fr">
      <div className="flex flex-wrap items-end justify-between gap-3" data-id="element-927" data-mp="2lihv77ihz9fy">
        <div data-id="element-928" data-mp="2qhufpllwc4fd">
          <h1 className="text-[22px] font-bold text-ink" data-id="element-929" data-mp="2qicmhc66q11j">
            Good morning, {currentUser.firstName}
          </h1>
          <p className="mt-1 text-[13px] text-gray-500" data-id="element-930" data-mp="r5rzqlchds6g">
            Friday, August 28 · <span className="font-semibold text-ink" data-id="element-931" data-mp="w39zbl4lyv1s">5 new leads</span>{' '}
            assigned today ·{' '}
            <span className="font-semibold text-danger" data-id="element-932" data-mp="2zd1bruf3lc0m">1 follow-up overdue</span> · 2 files
            stalled
          </p>
        </div>
        <button type="button" onClick={() => navigate('/follow-ups')} className="inline-flex items-center gap-2 rounded-lg bg-brand px-4 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-brand-dark focus:outline-none focus:ring-2 focus:ring-brand/40" data-id="element-933" data-mp="2ukrqiroxh04o">
          Start my day
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-934" data-mp="3eabm30g08bur" />
        </button>
      </div>

      <JumpPoints data-id="element-935" data-mp="39ayzmgt1p6sp" />

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1fr)_360px]" data-id="element-936" data-mp="39afqnpldhsqt">
        <div className="space-y-4" data-id="element-937" data-mp="34c4j5lijvubr">
          <QueueCard onSelect={lead => navigate(`/leads/${lead.id}`)} data-id="element-938" data-mp="34b2vmhkclfd5" />
          <AttentionCard onOpenLoan={loan => navigate(`/loans/${loan.id}`)} data-id="element-939" data-mp="1xwbq20ka56cs" />
          <ClosingsCard onOpenLoan={loan => navigate(`/loans/${loan.id}`)} data-id="element-940" data-mp="1swpcfq0jho3g" />
        </div>
        <div className="space-y-4" data-id="element-941" data-mp="1sz1zuip2gqnw">
          <ProductionSnapshot data-id="element-942" data-mp="1udmoc4tz3to4" />
          <ActivityFeed data-id="element-943" data-mp="1uenzsaewii6d" />
        </div>
      </div>

    </div>;
}